export function getParams (state){
    return state.params
}

export function getShowPromotionsModal (state){
    return state.showPromotionsModal
}




// WEBPACK FOOTER //
// ./src/b2b/modules/catalog/getters.js